import React from "react";
import { Select } from "../Select";

const CAPA_VALUE = "__capa__";
const GENERICA_VALUE = "__generica__";

interface MediaVariationSelectorProps {
  valorVariacao: string | null | undefined;
  valoresDisponiveis: string[];
  valoresOcupados?: string[];
  onChange: (valor: string | null) => void;
  disabled?: boolean;
}

export const MediaVariationSelector: React.FC<MediaVariationSelectorProps> = ({
  valorVariacao,
  valoresDisponiveis,
  valoresOcupados = [],
  onChange,
  disabled = false,
}) => {
  if (valoresDisponiveis.length === 0) return null;

  const options = [
    { name: "Todas as variações", value: GENERICA_VALUE },
    { name: "Foto do produto (capa)", value: CAPA_VALUE },
    ...valoresDisponiveis.map((v) => ({
      name: `Foto da variação p. ${v}`,
      value: v,
    })),
  ];

  // Filtrar valores já usados por outras fotos (exceto genérica que é ilimitada)
  const availableOptions = options.filter((opt) => {
    if (opt.value === GENERICA_VALUE) return true;
    const dbValue = opt.value === CAPA_VALUE ? "" : opt.value;
    return !valoresOcupados.includes(dbValue);
  });

  // Mapear valor do banco para valor do select
  const selectValue =
    valorVariacao === null || valorVariacao === undefined
      ? GENERICA_VALUE
      : valorVariacao === ""
        ? CAPA_VALUE
        : valorVariacao;

  return (
    <Select
      options={availableOptions}
      value={selectValue}
      onChange={(newValue) => {
        if (newValue === GENERICA_VALUE) onChange(null);
        else if (newValue === CAPA_VALUE) onChange("");
        else onChange(newValue);
      }}
      disabled={disabled}
    />
  );
};
